import type { ReactNode } from 'react';
import { useContact } from '../../partage/useArbre';
import { commentJoindre } from './contact';

/** Les morceaux communs aux deux pages publiques (ticket 05 du chantier comptes). */

/** Une partie de page : son titre, puis son texte. */
export function Partie({ titre, children }: { titre: string; children: ReactNode }) {
  return (
    <section className="page-publique-partie">
      <h2>{titre}</h2>
      {children}
    </section>
  );
}

/** À qui écrire : l'adresse posée par Igor (`npm run comptes -- contact`), ou la phrase de repli. */
export function Contact() {
  const { data, isPending, isError } = useContact();
  if (isPending) {
    return (
      <p className="page-publique-contact" aria-busy="true">
        <span aria-hidden="true">…</span>
      </p>
    );
  }
  const { adresse, phrase } = commentJoindre(isError ? null : data?.contact);
  return (
    <p className="page-publique-contact">
      {phrase}
      {adresse && (
        <>
          {' '}
          <a href={`mailto:${adresse}`}>{adresse}</a>
        </>
      )}
    </p>
  );
}

/** Un lien vers un autre site, qui s'ouvre à côté. */
export function LienExterne({ href, children }: { href: string; children: ReactNode }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
